var _circle, _circle2, _circle3, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNavPointer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 141,
    viewBox: "0 0 141 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70.5,
    cy: 70.5,
    r: 69,
    stroke: "white",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 70.4996,
    cy: 70.4996,
    r: 63.2442,
    fill: "white",
    fillOpacity: 0.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.49956,
    cy: 7.49956,
    r: 7.49956,
    transform: "matrix(-1 0 0 1 78.499 63)",
    fill: "white",
    fillOpacity: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M107.904 103.293C113.51 108.209 122.192 107.693 125.808 101.173C129.418 94.6621 131.869 87.5336 133.01 80.1055C134.839 68.204 133.232 56.0277 128.379 45.008C123.525 33.9882 115.627 24.583 105.612 17.8979C95.5971 11.2127 83.8818 7.5255 71.8434 7.26965C59.8049 7.0138 47.9436 10.1999 37.6536 16.4535C27.3637 22.7072 19.0728 31.7683 13.7556 42.5719C8.43842 53.3755 6.31587 65.4725 7.63745 77.441C8.46231 84.9109 10.6074 92.137 13.9381 98.7951C17.2739 105.463 25.9261 106.347 31.7361 101.675L49.9882 86.9955C54.0887 83.6977 54.3846 77.573 53.8071 72.3428V72.3428C53.4562 69.1647 54.0198 65.9524 55.4317 63.0836C56.8437 60.2148 59.0452 57.8087 61.7776 56.1481C64.51 54.4875 67.6597 53.6415 70.8564 53.7094C74.0531 53.7774 77.164 54.7565 79.8234 56.5316C82.4827 58.3068 84.5801 60.8043 85.8689 63.7305C87.1576 66.6567 87.5843 69.89 87.0986 73.0503V73.0503C86.2994 78.2513 86.3349 84.3831 90.2915 87.8521L107.904 103.293Z",
    fill: "white",
    fillOpacity: 0.9
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavPointer);
export default __webpack_public_path__ + "static/media/navPointer.48c97f2ab67345b9e55048cca9e45c27.svg";
export { ForwardRef as ReactComponent };